"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDomainRecords = void 0;
var toDomainRecords = function (record) {
    var _a;
    return ({
        address: record.address,
        data: JSON.stringify(record.data.raw()),
        name: record.name,
        expiry: (_a = record.expiry) === null || _a === void 0 ? void 0 : _a.toUTCString()
    });
};
exports.toDomainRecords = toDomainRecords;
//# sourceMappingURL=mapping.js.map